import { MasterHook, createAction, useStorage } from 'iomart-hooks';

interface Actions {
  showModal: <T extends {}>(type: string, params: T) => void;
  closeModal: (type: string) => void;
}

const storage = 'StreamData';

const initialState = {
  hasSearch: false as boolean,
  hasFilter: false as boolean,
  hasFilterFields: false as boolean,
  filterOpen: false as boolean,
  modals: {} as {[key: string]: {open: boolean, [key: string]: any}}
};

export const modalParams: {[key: string]: any} = {}

const actions: Actions = {
  showModal: createAction((type: string, params = {}) => {
    const { modals, setModals } = useStorage(storage);
    modalParams[type] = {
      ...params
    };
    setModals({ ...modals, [type]: { open: true } });
  }),
  closeModal: createAction((type: string) => {
    const { modals, setModals } = useStorage(storage);
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { [type]: _, ...rest } = modals;
    setModals({ ...rest });
    delete(modalParams[type])
  }),
};

const cache = {};

export const initReduxHook = {
  actions,
  storage,
  initialState,
  cache,
};

export const useRedux = MasterHook(initReduxHook);